module.exports = __webpack_public_path__ + "media/assets/images/landings/iot/screens/softphone_incoming_call-f36d756e249036bba62f4c44afed44d9.png";